import {
	Button,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	TextField,
	useMediaQuery,
	Link,
	ThemeProvider,
	createTheme,
	Pagination,
	CircularProgress,
} from "@mui/material"
import { useContext, useEffect, useState } from "react"
import { adminFindUserV2, adminGetUsersV2 } from "../util/firebase"
import { AdminContext } from "../views/Admin"
import { firebaseTimeStampToDate } from "../util/helpers"
import SendWhatsAppDialog from "./SendWhatsAppDialog"

const mdTheme = createTheme({
	palette: {
		primary: {
			main: "#132242",
		},
		secondary: {
			main: "#DF0A0A",
		},
		white: {
			main: "white",
		},
	},
	direction: "rtl",
})

const Users = () => {
	const adminContext = useContext(AdminContext)
	const handleUserDialogOpen = adminContext.handleUserDialogOpen
	const handleOpenSnackbar = adminContext.handleOpenSnackbar

	const matches = useMediaQuery(mdTheme.breakpoints.up("md"))

	const [query, setQuery] = useState("")
	/* const [user, setUser] = useState(null) */
	const [users, setUsers] = useState([])
	const [page, setPage] = useState(1)
	const [pageCount, setPageCount] = useState(1)
	const [noOfUsers, setNoOfUsers] = useState(0)

	const [sendWhatsAppOpen, setSendWhatsAppOpen] = useState(false)
	const [loading, setLoading] = useState(true)
	//const [nextPageToken, setNextPageToken] = useState(null)

	/* const _adminGetUsers = async (nextPageToken) => {
		const response = await adminGetUsersV2({ nextPageToken: nextPageToken })
		if (response.data.status === 0) {
			if (users.length > 0) {
				setUsers((prevState) => [...prevState, ...response.data.users])
			} else {
				setUsers(response.data.users)
			}
			if (response.data.pageToken) {
				setNextPageToken(response.data.pageToken)
			} else {
				setNextPageToken(null)
			}
		}
	} */

	const handleChange = async (event, value) => {
		//setPage(value)
		if (value === page + 1 && users.length < value * 100) {
			console.log(users[users.length - 1].id)
			const response = await adminGetUsersV2({
				lastTimeStamp: firebaseTimeStampToDate(users[users.length - 1].createdDateTime).getTime() + 1,
			})
			if (response.data.status === 0) {
				setUsers((prevState) => [...prevState, ...response.data.users])
				setPageCount(response.data.noOfPages)
			}
		}
		if (users.length >= (value - 1) * 100 || users.length === noOfUsers) setPage(value)
	}

	const _adminGetUsers = async () => {
		setLoading(true)
		const response = await adminGetUsersV2({})
		setLoading(false)
		if (response.data.status === 0) {
			setUsers(response.data.users)
			setPageCount(response.data.noOfPages)
			setNoOfUsers(response.data.noOfUsers)
		}
	}

	useEffect(() => {
		if (page === 1 && users.length === 0) {
			_adminGetUsers()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const findUser = () => {
		setLoading(true)
		adminFindUserV2({ query: query })
			.then((response) => {
				setLoading(false)
				//setUser(response.data)
				setUsers(response.data.users)
				setNoOfUsers(response.data.users?.length)
				setPage(1)
				setPageCount(1)
			})
			.catch((e) => {
				setLoading(false)
				handleOpenSnackbar("משתמש לא נמצא!", "error")
				console.log(e)
			})
	}

	const resetForm = () => {
		setUsers([])
		_adminGetUsers()
		setQuery("")
	}
	const handleFieldChange = (e) => {
		setQuery(e.target.value)
	}

	return (
		<ThemeProvider theme={mdTheme}>
			<SendWhatsAppDialog sendWhatsAppOpen={sendWhatsAppOpen} setSendWhatsAppOpen={setSendWhatsAppOpen} />
			<Paper sx={{ p: 2, display: "flex", flexDirection: "column", mb: 2 }}>
				<Button
					variant="contained"
					sx={{ mr: 2, mb: 2, backgroundColor: "green", maxWidth: matches ? "200px" : "none" }}
					fullWidth={!matches}
					onClick={() => setSendWhatsAppOpen(true)}
				>
					שליחת וואטסאפ
				</Button>
				{/* <Typography variant="h6" sx={{ mb: 2 }}>
					חיפוש לפי:
				</Typography> */}
				<div style={{ display: "flex", flexDirection: matches ? "row" : "column" }}>
					{/* <TextField
						label={"אימייל"}
						value={email ?? ""}
						onChange={(e) => handleFieldChange(e, "email")}
						fullWidth={!matches}
						sx={{ mb: matches ? 0 : 2, mr: matches ? 2 : 0 }}
						size="small"
					/> */}
					<TextField
						label={"חיפוש לפי..."}
						value={query ?? ""}
						onChange={(e) => handleFieldChange(e)}
						fullWidth={!matches}
						sx={{ mb: matches ? 0 : 2, mr: matches ? 2 : 0 }}
						size="small"
					/>
					<Button variant="contained" sx={{ mr: 2, mb: 2 }} fullWidth={!matches} onClick={findUser}>
						חיפוש
					</Button>
					<Button
						variant="contained"
						sx={{ mb: 2, backgroundColor: mdTheme.palette.secondary.main }}
						fullWidth={!matches}
						onClick={resetForm}
					>
						איפוס
					</Button>
				</div>
				{matches ? (
					<Table sx={{ mt: 2 }}>
						<TableHead>
							<TableRow>
								<TableCell>שם</TableCell>
								<TableCell>אימייל</TableCell>
								{/* <TableCell>מאומת</TableCell> */}
								<TableCell>טלפון</TableCell>
								<TableCell>נוצר בתאריך</TableCell>
							</TableRow>
						</TableHead>
						{loading ? (
							<TableBody>
								<TableRow>
									<TableCell colSpan={4}>
										<Paper
											sx={{
												p: 2,
												display: "flex",
												flexDirection: "column",
												height: 100,
												justifyContent: "center",
												alignItems: "center",
											}}
										>
											<CircularProgress />
										</Paper>
									</TableCell>
								</TableRow>
							</TableBody>
						) : (
							<TableBody>
								{users
									.filter((e, i) => i >= (page - 1) * 100 && i < page * 100)
									.map((user) => (
										<TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }} key={user.email}>
											<TableCell>{user?.displayName}</TableCell>
											<TableCell>
												{user?.email && (
													<Link sx={{ cursor: "pointer" }} onClick={() => handleUserDialogOpen(user?.email)}>
														{user?.email}
													</Link>
												)}
											</TableCell>
											{/* <TableCell>
											<Checkbox checked={user?.emailVerified ?? false} disabled />
										</TableCell> */}
											<TableCell>{user?.phone}</TableCell>
											<TableCell>{firebaseTimeStampToDate(user.createdDateTime).toLocaleString("he")}</TableCell>
										</TableRow>
									))}
							</TableBody>
						)}
					</Table>
				) : (
					<>
						{users
							.filter((e, i) => i >= (page - 1) * 100 && i < page * 100)
							.map((user) => (
								<Paper sx={{ p: 2, display: "flex", flexDirection: "column", mb: 2 }} key={user.email}>
									<Table sx={{ tableLayout: "fixed", mt: 2 }}>
										<TableBody>
											<TableRow>
												<TableCell variant="head" sx={{ fontWeight: 600 }}>
													שם
												</TableCell>
												<TableCell>{user?.displayName}</TableCell>
											</TableRow>
											<TableRow>
												<TableCell variant="head" sx={{ fontWeight: 600 }}>
													אימייל
												</TableCell>
												<TableCell sx={{ wordWrap: "break-word" }}>
													{user?.email && (
														<Link sx={{ cursor: "pointer" }} onClick={() => handleUserDialogOpen(user?.email)}>
															{user?.email}
														</Link>
													)}
												</TableCell>
											</TableRow>
											{/* <TableRow>
												<TableCell variant="head" sx={{ fontWeight: 600 }}>
													מאומת
												</TableCell>
												<TableCell>
													<Checkbox checked={user?.emailVerified ?? false} disabled />
												</TableCell>
											</TableRow> */}
											<TableRow>
												<TableCell variant="head" sx={{ fontWeight: 600 }}>
													טלפון
												</TableCell>
												<TableCell>{user?.phone}</TableCell>
											</TableRow>
											<TableRow>
												<TableCell variant="head" sx={{ fontWeight: 600 }}>
													נוצר בתאריך
												</TableCell>
												<TableCell>{firebaseTimeStampToDate(user.createdDateTime).toLocaleString("he")}</TableCell>
											</TableRow>
										</TableBody>
									</Table>
								</Paper>
							))}
					</>
				)}
				<Pagination count={pageCount} page={page} onChange={handleChange} size={matches ? "medium" : "small"} />
			</Paper>
		</ThemeProvider>
	)
}

export default Users
